import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';

import Reducer from './Reducers';

const middleware = routerMiddleware(browserHistory);

const store = createStore(
  Reducer,
  applyMiddleware(middleware),
);

export default store;



// WEBPACK FOOTER //
// ./src/config/Store.js